import {createElementFromHTML, initClassParams} from './functions';

export default class AdsModal {
  constructor(trigger, params = {}) {
    this.$trigger = trigger;
    this.$modal = null;
    this.$background = null;
    this.params = initClassParams(this.defaultParams(), params)

    this.initListeners();
  }

  defaultParams() {
    return {
      title: 'Annonsering på sajten',
      text: 'CreditCards.com is an independent, advertising-supported comparison service. The offers that appear on this site are from companies from which CreditCards.com receives compensation. This compensation may impact how and where products appear on this site, including, for example, the order in which they may appear within listing categories. Other factors, such as our own proprietary website rules and the likelihood of applicants\' credit approval also impact how and where products appear on this site. CreditCards.com does not include the entire universe of available financial or credit offers.',
      button: 'OK',
    }
  }

  initListeners() {
    this.$trigger.addEventListener('click', () => {
      this.show();
    })
  }

  show() {
    if (!this.$modal && !this.$background) {
      document.body.classList.add('no-scroll')

      this.$background = document.body.appendChild(createElementFromHTML(this.background()))
      this.$modal = document.body.appendChild(createElementFromHTML(this.template()))
      this.templateListeners(this.$modal, this.$background)

      process.nextTick(() => {
        this.$modal.style.opacity = 1;
        this.$background.style.opacity = 1;
      })
    }
  }

  hide() {
    document.body.classList.remove('no-scroll')

    this.$modal.style.opacity = 0;
    this.$background.style.opacity = 0;

    setTimeout(() => {
      this.$background.remove();
      this.$modal.remove();

      process.nextTick(() => {
        this.$background = null;
        this.$modal = null;
      })
    }, 350)
  }

  template() {
    return `<div class="c-modal"><button class="c-modal--close" data-trigger="close"></button><div class="c-modal--inner"><h2 class="section-title">${this.params.title}</h2>${this.params.text}<button data-trigger="close" class="button button-default">${this.params.button}</button></div></div>`;
  }

  templateListeners(elem, background) {
    elem.querySelectorAll('[data-trigger="close"]').forEach(x => {
      x.addEventListener('click', () => {
        this.hide();
      })
    })

    background.addEventListener('click', () => {
      this.hide()
    })
  }

  background() {
    return '<div class="c-modal--background"></div>';
  }
}



// WEBPACK FOOTER //
// ./scripts/libs/AdsModal.js